var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('base-dialog', {
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.overlay
  }, [_vm.$slots.hasOwnProperty('title') ? _c('div', {
    class: _vm.$style.title
  }, [_vm._t("title")], 2) : _vm._e(), _c('div', {
    directives: [{
      name: "scrollbar",
      rawName: "v-scrollbar",
      value: {
        id: "scrollbar-".concat(_vm.scrollbarId)
      },
      expression: "{ id: `scrollbar-${scrollbarId}` }"
    }],
    class: _vm.$style.content
  }, [_c('scrollbar-vertical', {
    class: _vm.$style.scrollbar,
    attrs: {
      "id": "scrollbar-".concat(_vm.scrollbarId)
    }
  }), _vm._t("content")], 2)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }